<template>
	<div>
		<span class="name">{{info.mberNm}}</span>
		<span class="age">({{info.gender | gender}})</span>

		<span v-if="isAdmin">
			<span v-if="(info.empDivCd == null || info.empDivCd =='')" class="cmp corp_state_ing"><template>- 소속사 미등록 -</template></span>
			<span v-else-if=" info.mberAsgInfo.asgApprStatus == '02'" class="cmp corp_state_ing">- 승인 처리중 -</span>
			<span v-else-if=" info.mberAsgInfo.asgApprStatus == '04'" class="cmp corp_state_ing">- 퇴사 처리중 -</span>
			<span v-else class="cmp">{{ info.mberAsgInfo.corpNm || '소속없음'}} / <SelectComp v-model="info.mberAsgInfo.empDivCd" type="text" cdId="PRO102"/></span>
		</span>	

		<div class="mem_num">
			<div v-if="isMy" class="state">
				<div>프로젝트 참여 가능</div>
				<div class="dev_state">
					{{possDate | date('yyyy. MM. dd 부터')}}
				</div>
				<div class="set-btn btn_cursor" @click="changeDevState()">설정 &#9654;</div>
			</div>
			<div v-else class="state">
				<div>프로젝트 참여 가능</div>
				<div class="dev_state">
					{{possDate | date('yyyy. MM. dd 부터')}}
				</div>
			</div>
			<!-- <div v-if="isMy" class="img_box">
				<div class="state" @click="changeDevState()">
					<img src="/images/tec/myp/mypage_develop_p.png" alt="참여가능날짜 설정" />
					<div class="dev_state">
						<div class="text">
							{{possDate | date('yyyy. MM. dd 부터')}}
						</div>
					</div>
				</div>
			</div>
			<div class="img_box" v-else>
				<div v-if="possDate != '-'">
					<img src="/images/tec/myp/project_possible.png" alt="참여가능"/>
					<span v-if="isPmg" class="dev_state_pmg">{{possDate | date('yyyy. MM. dd')}} 부터</span>
					<span v-else class="dev_state">{{possDate | date('yyyy. MM. dd')}} 부터</span>
				</div>
				<div v-else>
					<img src="/images/tec/myp/project_impossible.png" alt="참여불가능"/>
				</div>
			</div> -->
		</div>

	</div>
</template>

<script>
export default {
	props:{
		value:Object
	},

	updated() {
		//console.log("mounted");
		//console.log(this.value);
	},
	computed:{
		info(){
			return this.value && this.value.tecSeq ? this.value : {};
		},
		isAdmin() { return this.$store.getters.isAdmin },
		isMy() { return this.$store.state.userInfo.mberSeq == this.info.tecSeq },
		isPmg() { return this.$store.state.userInfo.mberDivCd == '22'; },
		possDate() {
			return this.value.joinPossYyyymmdd ? this.value.joinPossYyyymmdd : '-'
		}
	},
	
	methods : {
		changeDevState() {
			var param = {
				value : this.value
			}
			this.$.popup('/tec/myp/MYP101P01', param)			
		},
	}
}
</script>